module.exports = __webpack_public_path__ + "img/delete.5de10fd7.png";